import React from "react";
import store from "../store";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import ReactPlayer from "react-player";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import hideOnScroll from '../components/hideonscroll'
import CompWait from './CompWait'
import CompSee from './CompSee'
import CompListen from './CompListen'
import CompOnline from './CompOnline'
import CompRank from './CompRank'
import MenuIcon from '@material-ui/icons/Menu';

import { NotificationManager } from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Link } from "react-router-dom";

import TopBar from '../components/TopBar2';
import Paper from '@material-ui/core/Paper';

import { Redirect } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import PowerIcon from '@material-ui/icons/PowerSettingsNew';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import * as STATIC from '../config/static';
import _ from 'lodash';
import moment from "moment"
const DWIDTH = 1024;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
function getParameterByName(name) {
    if (name !== "" && name !== null && name !== undefined) {
        name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(window.location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    } else {
        var arr = window.location.href.split("/");
        return arr[arr.length - 1];
    }
}
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
function validatePhone(phone) {
  var re = /^([0-9]{6,20})$/;
  return re.test(phone);
};

const firestore = firebase.firestore();
//let IS_NAMING = window.location.hostname.toLowerCase()=='www1.namethegiraffe.com'?true:false;
//IS_NAMING = true;


var _this;

class CompHome extends React.Component {
  state = {
    viewDidLoad: false,
  };
  constructor() {
    super();

    _this = this;
    this.state={online:0,isPlaying:false,loaded:false,comp:null,curLevel:null,curRoundIndex:0,showWait:false,showCM:false,rules:false,curPartIndex:0
      ,loading:true,showRound:null,saving:false,saving_error:false,timeInt:0,showRank:-1,showRRules:-1,aList:{},forceStart:null,loadedAudio:false}
    _this.audio = new Audio("assets/sound/inner_bg.mp3");
  }
  updateDimensions() {
    //console.log(window.innerWidth);
    // _this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
  }
  async componentDidMount() {

    let rel = await STATIC.loadJSONData(STATIC.API_GETTIME);
    if(rel&&rel.status==1)
    {
      let timeInt = moment().valueOf()-moment(rel.time).valueOf();
      //console.log(timeInt,moment().subtract(timeInt,"ms").format("HH:mm:ss"));
      if(timeInt>-1000&&timeInt<1000)
      timeInt = 0;
      //console.log(timeInt,moment().subtract(timeInt,"ms").format("HH:mm:ss"));
    _this.setState({timeInt});
    }
  window.addEventListener("beforeunload", this.unloadCallback);

    let checked = await STATIC.checkVersion();
    if(checked!=true)
    {
      store.dispatch({ type: 'UP_VER', UP_VER: checked });
    }
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    //this.loadAudios();
    //let encrypted = STATIC.encryptStringWithRsaPublicKey("JK1234");
    //console.log(encrypted);


    // this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
    //window.addEventListener("resize", this.updateDimensions);
    let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;
    if(ACCOUNTCOMP)
    {
      this.updateOnline();
      this.checkToken();
      this.loadComp();
    }

  }
  async updateOnline(){
    let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;
    let sub3 = firebase.firestore().collection('componline').doc("counter").onSnapshot((doc)=>{
        if(doc)
        {
          let data = doc.data();
          _this.setState({online:data[ACCOUNTCOMP.comp_id]||0})
        }
      //console.log(results);
    //  _this.setState({results});
    });
    _this.setState({sub3});
    //let doc =
    firebase.firestore().collection('componline').doc("counter").collection("onlines").doc(ACCOUNTCOMP.id).set({created:(new Date().getTime()),compId:ACCOUNTCOMP.comp_id},{merge:true});
    _this.interval = setInterval(()=>{
      firebase.firestore().collection('componline').doc("counter").collection("onlines").doc(ACCOUNTCOMP.id).set({created:(new Date().getTime()),compId:ACCOUNTCOMP.comp_id},{merge:true});
    },60*1000);
  }
  fetchAudio(key)
  {
    let LANG = "vn2";
    let url = "assets/sound/"+LANG+"/"+LANG+"_"+key+".mp3";
    fetch(url)
    .then(response => response.blob())
    .then(blob => {
      let uri = URL.createObjectURL(blob);
        _this.state.aList[LANG+"_"+key]=new Audio(uri);
        
        //console.log(uri)
    });
  }
  getAudioList(){
    let arr = {};
    let {curLevel} = this.state;
   //console.log(curLevel.rounds.length);
          for(let r of curLevel.rounds)
          {
            if(r.parts&&r.parts[0].type=="listen")
              {
                for(let p of r.parts)
          {
            for(let s of p.sets)
            {
              for(let q of s.questions)
              {
                for(let n of q.numbers)
                {
                  arr[(Math.abs(n)).toString()] = Math.abs(n);
                }
              }
            }
          }
              }
          }
        console.log(arr);
        return arr;
  }
  async loadAudios(){

    let list = _this.getAudioList();
   // return;
    if(_this.state.loadedAudio&&_this.state.aList.length>0){
      return;
    }
    let arr = ["minus","plus","equal","divide","multi"];
    
    // for(let i=0;i<1000;i++)
    // {
    //   arr.push(i.toString());
    // }
    for(let n of Object.keys(list))
    {
      //console.log(list);
      arr.push(n.toString());
    }
    console.log(arr);
    for(let a of arr)
    {
      this.fetchAudio(a);
    }
    _this.state.aList["s1"]=new Audio("assets/sound/s1.mp3");
    _this.state.aList["s2"]=new Audio("assets/sound/s2.mp3");
    _this.state.aList["s3"]=new Audio("assets/sound/s3.mp3");
    _this.state.aList["w1"]=new Audio("assets/sound/w1.mp3");
    _this.state.aList["w2"]=new Audio("assets/sound/w2.mp3");
    _this.state.aList["w3"]=new Audio("assets/sound/w3.mp3");
    _this.state.aList["yay"]=new Audio("assets/sound/yay.mp3");
  }
  async checkToken(){

    let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;
    //console.log("Check TOken",ACCOUNTCOMP.id);
    if(_this.state.sub2)
    _this.state.sub2();
    let sub2 = firebase.firestore().collection('comp_token').where("acc_id","==",ACCOUNTCOMP.id).onSnapshot((data)=>{
      let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;

      let ACCOUNTCOMP_TOKEN = store.getState().ACCOUNTCOMP_TOKEN;
      //console.log(ACCOUNTCOMP_TOKEN)
      //let results = [];
      let found = false;
      if(data.size>0)
      {
        data.forEach((doc) => {
          let item = doc.data();
          if(item.id == ACCOUNTCOMP_TOKEN.id&&item.acc_id==ACCOUNTCOMP.id)
          {
            found = true;
          }
        });

      }
      if(!found)
      {
        STATIC.NotificationManager.error("Bạn đã bị đăng xuất vì đăng nhập trên thiết bị khác.");
        localStorage.removeItem('ACCOUNTCOMP');
        store.dispatch({ type: 'ACCOUNTCOMP', ACCOUNTCOMP: false });
      }
      //console.log(results);
    //  _this.setState({results});
    });
    _this.setState({sub2});
  }
  async loadComp(){
    let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;
    if(this.state.sub)
    this.state.sub();
    let _this = this;
    let sub = firebase.firestore().collection('comps').where('comp_id',"==",ACCOUNTCOMP.comp_id).onSnapshot((data)=>{
      let comp = null;

      if(data.size>0)
      {

        data.forEach(d=>{
          comp = d.data();
          comp.id = d.id;
        })
      }
      //console.log("Data");
      _this.setState({comp});
      if(!_this.state.loaded)
      {
        _this.setState({loaded:true,loading:false});
      }
      if(comp)
      {
        let curLevel = comp.levels[ACCOUNTCOMP.level];
        if(curLevel)
        {
          let forceStart = null;
          let curRoundIndex = 0;
          for(let r of curLevel.rounds)
          {
            let now = moment().subtract(_this.state.timeInt,"ms");
            if(moment(r.startTime).isSameOrBefore(now))
            {
              let diff = moment(now).diff(moment(r.startTime),"seconds");
              //console.log(diff);
              if(r.parts&&r.parts[0].type=="see")
              {
                let setIndex = 0;
                if(r.parts[0].sets)
                {
                  let remainTime = 0;
                  let sTime = 0;
                  let j = 0;
                  for(j = 0;j<r.parts[0].sets.length;j++)
                  {
                    let s = r.parts[0].sets[j];
                    
                    sTime += parseInt(s.time);
                    
                    if(diff<sTime-30)
                    {
                      remainTime = parseInt(s.time)-diff;
                       break;
                    }
                   
                  }
                  if(remainTime>0)
                  {
                    forceStart = {remain:remainTime,setIndex:j};
                    break
                  }
                }
                
              }
            }
            if(moment(r.startTime).isSameOrAfter(now))
            {
              break;
            }
            
            curRoundIndex++;
          }
          let showRound = null;
          if(curRoundIndex<curLevel.rounds.length&&forceStart)
          {
            showRound=curLevel.rounds[curRoundIndex];
          }
          _this.setState({curRoundIndex,showRound,curLevel,forceStart})
        }

      }
    })
    _this.setState({sub});
    //let data = await firebase.firestore().collection('comps').where('comp_id',"==",ACCOUNTCOMP.comp_id).get();


    //console.log(sDoc.exists)

  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload",this.unloadCallback);
    window.removeEventListener('resize', this.updateWindowDimensions);
    if(this.state.sub)
    this.state.sub();
    if(this.state.sub2)
    this.state.sub2();
    if(this.state.sub3)
    this.state.sub3();
    if(this.interval)
    {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  updateWindowDimensions() {
    _this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }
  unloadCallback(event) {
    // if(window.confirm("Bạn có muốn rời khỏi trang? Nếu bạn đang thi thì sẽ không thể tiếp tục thi nữa!!!!"))
    // console.log("test");
    event.preventDefault();
    event.returnValue = "";
    return "";
    //_this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }
  handleChange = name => event => {
    //event.preventDefault();
    _this.setState({ [name]: event.target.value });
  };



  getName(fullname)
  {
    return _.last(fullname.split(' '));
  }

  onWaitEnd()
  {
    const { comp,curRoundIndex,curLevel } = this.state;
    let curRound = curLevel.rounds[curRoundIndex];
    _this.setState({showWait:false,curPartIndex:0,showRound:curRound})
  }
  onSetEnd(questions,setIndex,remain=0,isEnd=false) {
    //console.log(questions);
    _this.setState({forceStart:null});
    const { comp,curRoundIndex,curLevel,curPartIndex,showRound,showCM } = _this.state;
    let curSet = showRound.parts[curPartIndex].sets[setIndex];
    let config = curSet.config;
    let count = 0;
    let countCorrect = 0;
    let totalPoint = 0;

    for (let q of questions) {
      q.status=0;

      if(Number(q.answer)==Number(q.result))
      {
        q.status=1;
        countCorrect++;
        totalPoint+=Number(config.point);
        if(q.point_r>0)
        {
          totalPoint+=q.point_r;
        }
      }
    }
    if(remain>0)
    {
      totalPoint+=remain*Number(config.point_r);
    }

    //console.log(totalPoint);
    // if(count==countCorrect&&count==questions.length)
    // {
    //   _this.setState({showSignUp:true});
    // }
    STATIC.NotificationManager.success("Tổng điểm set "+(setIndex+1)+": "+totalPoint);

    let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;

    if(isEnd)
    {
      if(curPartIndex<showRound.parts.length-1)
      {
        _this.setState({curPartIndex:curPartIndex+1});
      }
      else {
        if(curRoundIndex<curLevel.rounds.length-1)
        {
          _this.setState({curPartIndex:0,showWait:true,showRank:curRoundIndex,curRoundIndex:curRoundIndex+1,showRound:false});
          let showRankTime = parseInt(comp.showRankTime)||60;
          setTimeout(()=>{

            _this.setState({showRank:-1})
          },showRankTime*1000);
        }
        else {
          STATIC.NotificationManager.success("Cuộc thi đã kết thúc!!");
          _this.setState({curPartIndex:0,showWait:false,showRound:false,showRank:curRoundIndex});
          setTimeout(()=>{

            _this.setState({showRank:-1})
          },60*1000);
        }

      }

    }
let nResult = {questions,countCorrect,qlength: questions.length};
      nResult.comp_id=comp.comp_id;
      nResult.comp_doc_id = comp.id;

      nResult.competitor_id = ACCOUNTCOMP.id;
      nResult.round = curRoundIndex;
      nResult.level = ACCOUNTCOMP.level;
      nResult.part = curPartIndex;
      nResult.set = setIndex;
      nResult.point = totalPoint;
      _this.setState({nResult});
      _this.postResultToServer(nResult);
  }
  async postResultToServer(result,count=0){
  //  console.log("post result");
  if(!result)
  {
    _this.setState({saving:false,saving_error:false});
    return;
  }
  await  _this.setState({saving:true,saving_error:false});

    //console.log(JSON.stringify(result));
    //return;
    //let res = await STATIC.postFormData("http://localhost:5000/vnsuperbrain/us-central1/Student_PostResultAdvance2",{result:JSON.stringify(result)});
    let res = await STATIC.postFormData(STATIC.API_COMP_POSTRESULT,{result:JSON.stringify(result)});
    //console.log(res);
    if(res)
    {
      if(res.status==0)
      {
        if(res.message=='Key not correct')
        {
          await  _this.setState({saving:false});

        }
        else {
          //await  _this.setState({saving_error:true});
          if(count<2)
          _this.postResultToServer(result,count+1);
          let docid = "C"+(new Date().getTime());
          firebase.firestore().collection("results_error").doc(docid).set({...result,type:'competiton',created:(new Date().getTime())});
        }
      }
      else {
        await  _this.setState({saving:false});

      }
    }
    else {
      if(count<2)
      _this.postResultToServer(result,count+1);
      let docid = "C"+(new Date().getTime());
      firebase.firestore().collection("results_error").doc(docid).set({...result,type:'competiton',created:(new Date().getTime())});
    }

  }
  render() {
    const { classes,t } = this.props;
    const { loading,loaded,saving,saving_error, wWidth, wHeight,comp,rules,showWait,showRound,curRoundIndex,curLevel,curPartIndex,showRank,showRRules,aList,forceStart } = this.state;
    let width = 1024;
    let height = 640;

    // if (wWidth < width) {
    //   width = wWidth;
    // }

      height = wHeight;

    let sRate = 1024 / 640;
    let tRate = 1371 / 848;
    let asRate = 121 / 2048;
    let tsRate = 1370/2048;
    //if (width / wHeight > sRate) {
      width = wHeight * sRate;
      if(width>wWidth)
      {
          width = wWidth;
          height = width/sRate;
      }
    let tWidth = width*tsRate;
    let tHeight = tWidth/tRate;
    //}
    let fBig = width * 0.07;
    let fLarge = width * 0.06
    let fNQ = width * 0.05;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let fSmaller = width * 0.015;
    let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;
    let SOUND = store.getState().SOUND;

    if (!ACCOUNTCOMP) {
      let comp_id = getParameterByName("id");
      if(comp_id&&comp_id.length>0)
      return (<Redirect to={'/competition_login?id='+comp_id} />);
      return (<Redirect to='/competition_login' />);
    }
    //console.log(ACCOUNTCOMP)
    if(!ACCOUNTCOMP.active||ACCOUNTCOMP.active==0)
    {
      return (
        <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle} >
          <TopBar width={width} />
                <center>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

                    <div>
                    <div className="comp_text_gradient"  style={{fontSize:fBig,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(640 , DWIDTH, width)*377/1427/3+"px" }}>{"Tài khoản chưa được kích hoạt"}</div>
                    </div>

                </div>


                </center>
            </div>
        </div>
      );
    }

let shareUrl = `/comp_ranking?comp=${comp?comp.comp_id:""}&u=${ACCOUNTCOMP.id}&level=${ACCOUNTCOMP.level+1}&round=${curRoundIndex}`
    let bWidth = STATIC.calSize(512, DWIDTH, width);
    //console.log(ACCOUNT);
    if(loading)
    {
      return (
        <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle} >
                <center>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

                    <div>
                    <CircularProgress color="secondary"/>
                    </div>

                </div>

                </center>
                <div style={{position:'fixed',bottom:STATIC.calSize(5, DWIDTH, width),left:STATIC.calSize(5,DWIDTH, width)}}>
                  <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>Online: {this.state.online}</div>

                </div>
            </div>
        </div>
      );
    }
    if(saving_error==true)
    {
      return (
        <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle} >
                <center>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

                  <div>
                  <div className="comp_text_gradient"  style={{fontSize:fLarge,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(640 , DWIDTH, width)*377/1427/3+"px" }}>{"Lưu không thành công\nhãy thử lại"}</div>
                  </div>
                  <Grid container direction="row" alignItems="center" justify="center">
                    <Grid item xs={12}  alignItems="center" justify="center" style={{display:"flex", margin: STATIC.calSize(20, DWIDTH, width), position: 'relative' }}>
                      <ButtonBase onClick={(e)=>this.postResultToServer(this.state.nResult)}  style={{ textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center',backgroundImage:"url('assets/comp/button.png')",backgroundSize:"100% 100%", width: STATIC.calSize(200 , DWIDTH, width),height:STATIC.calSize(200 , DWIDTH, width)*155/493, marginBottom: STATIC.calSize(30, DWIDTH, width) }}>
                          <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>Thử lại</div>
                      </ButtonBase>

                    </Grid>
                  </Grid>

                </div>

                </center>
                <div style={{position:'fixed',bottom:STATIC.calSize(5, DWIDTH, width),left:STATIC.calSize(5,DWIDTH, width)}}>
                  <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>Online: {this.state.online}</div>

                </div>
            </div>
        </div>
      );
    }
    if(showRank!=-1)
    {
      return (
        <CompRank online={this.state.online} round={showRank} comp={comp} />
      );
    }
    if(loaded&&(comp==null||(curLevel&&curRoundIndex==curLevel.rounds.length)))
    {
      return (
        <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle} >
          <TopBar width={width} />
                <center>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

                    <div>
                    <div className="comp_text_gradient"  style={{fontSize:fBig,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(640 , DWIDTH, width)*377/1427/3+"px" }}>{"Chúc Mừng\nCác thí sinh\n hoàn thành bài thi"}</div>
                    </div>

                </div>
                {curRoundIndex>0&&<ButtonBase onClick={()=>window.open(shareUrl,"_blank")} style={{position:'absolute',paddingLeft:STATIC.calSize(20, DWIDTH, width),paddingRight:STATIC.calSize(20, DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center',backgroundImage:"url('assets/comp/button.png')",backgroundSize:"100% 100%",top:STATIC.calSize(50, DWIDTH, width),right:STATIC.calSize(10,DWIDTH, width)}}>
                  <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{"Xem lại kết quả"}</div>
                </ButtonBase>}

                </center>
                <div style={{position:'fixed',bottom:STATIC.calSize(5, DWIDTH, width),left:STATIC.calSize(5,DWIDTH, width)}}>
                  <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>Online: {this.state.online}</div>

                </div>
            </div>
        </div>
      );
    }
    if(showWait&&curLevel)
    {
      let curRound = curLevel.rounds[curRoundIndex];
      //console.log("showWait",_this.state.timeInt);
      let now = moment().subtract(_this.state.timeInt,"ms");
      let remain = moment(curRound.startTime).diff(now,"seconds");
      if(showRRules!=curRoundIndex)
      {
        return (
          <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
            <div className={classes.middle} >
    <TopBar width={width} />



                <div className={classes.square} style={{maxWidth:width, width: width,height:height,backgroundImage: comp&&comp.bg_nq&&comp.bg_nq.length>0?("url('"+comp.bg_nq+"')"):"url('assets/comp/bg_nq.png')",
                backgroundPosition: "center center",
                WebkitBackgroundSize: "100% 100%",
                backgroundSize: "100% 100%",position:'relative' }} elevation={4}>

                  <div style={{paddingTop:STATIC.calSize(120, DWIDTH, width) + 'px '}}>{" "}</div>
                  <div style={{  flexGrow: 1, position: 'relative' }}>

                    <div style={{ display: 'flex', height: tHeight,flexDirection:'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div  style={{width: tWidth,height:tHeight,backgroundImage: "url('assets/comp/nq_table.png')",
                    backgroundPosition: "center center",
                    WebkitBackgroundSize: "100% 100%",
                    backgroundSize: "100% 100%",position:'relative' }} elevation={4}>
                    <div className="comp_table" style={{color:"#37e73e",height:tHeight-STATIC.calSize(160, DWIDTH, width),marginBottom: STATIC.calSize(60, DWIDTH, width),marginTop: STATIC.calSize(60, DWIDTH, width),marginRight: STATIC.calSize(60, DWIDTH, width),marginLeft: STATIC.calSize(60, DWIDTH, width),fontSize:fSmaller,whiteSpace: "pre-wrap",overflowX:'hidden',wordWrap: "break-word"}}>
                      {curRound.rules}
                    </div>
                    {false&&<ButtonBase onClick={()=>{this.loadAudios();this.setState({rules:true,showWait:true})}} style={{position:'absolute',bottom:STATIC.calSize(70, DWIDTH, width),right:STATIC.calSize(60, DWIDTH, width),color:"#37e73e",
                    textShadow: "0px 0px 10px #edfb6a",fontSize:fSmall}}>
                      {t("comp.agree")}
                    </ButtonBase>}
                    <ButtonBase onClick={()=>{if(_this.raudio)_this.raudio.pause();_this.raudio=undefined;this.loadAudios();this.setState({isPlaying:false,showRRules:curRoundIndex})}}  style={{position:'absolute',paddingLeft:STATIC.calSize(20, DWIDTH, width),paddingRight:STATIC.calSize(20, DWIDTH, width),bottom:STATIC.calSize(5, DWIDTH, width),right:STATIC.calSize(60, DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center',backgroundImage:"url('assets/comp/button.png')",backgroundSize:"100% 100%", marginBottom: STATIC.calSize(60, DWIDTH, width) }}>
                        <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{t("comp.understand")}</div>
                    </ButtonBase>

                    </div>

                  </div>
                  </div>
                  <div style={{width,position:'absolute',bottom:STATIC.calSize(60, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                    <div className="comp_text_gradient"  style={{fontSize:fNQ,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(640 , DWIDTH, width)*377/1427/3+"px" }}>{t("comp.instruction",{round:(curRound.name||(curRoundIndex+1))})}</div>
                  </div>
                  <div style={{width,position:'absolute',bottom:STATIC.calSize(1, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                    <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>{ACCOUNTCOMP.id}</div>

                  </div>
                  <div  style={{position:'absolute',top:STATIC.calSize(10, DWIDTH, width),left:STATIC.calSize(375,DWIDTH, width),width:width*574/2048,height:(width*574/2048)*377/1427,backgroundImage:"url('assets/comp/square_name.png')",backgroundSize:"100% 100%", textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
                    <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:0.8}}>{comp?comp.name:"SUPERBRAIN\nSPEED MATH"}</div>
                  </div>
                  <div  style={{position:'absolute',top:STATIC.calSize(10, DWIDTH, width),left:STATIC.calSize(280,DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
                    <img
                      src="assets/comp/sp_logo_red.png"
                      style={{ width: width*154/2048, height: 'auto', display: 'block' }} />
                  </div>
                  <ButtonBase onClick={()=>{

                      if(this.state.isPlaying)
                      _this.raudio.pause();
                      else
                      {
                        if(curRound.rules_audio&&curRound.rules_audio.length>0&&_this.raudio==undefined)
                        _this.raudio = new Audio(curRound.rules_audio);
                        _this.raudio.play();
                      }

                      this.setState({isPlaying:!this.state.isPlaying})}} style={{position:'absolute',top:STATIC.calSize(50, DWIDTH, width),left:STATIC.calSize(80,DWIDTH, width)}}>
                    <img
                      src="assets/comp/speaker.png"
                      style={{ width: width*asRate, height: 'auto', display: 'block' }} />
                  </ButtonBase>
                </div>
                <div style={{position:'fixed',bottom:STATIC.calSize(5, DWIDTH, width),left:STATIC.calSize(5,DWIDTH, width)}}>
                  <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>Online: {this.state.online}</div>

                </div>
            </div>
          </div>
        );
      }
      //console.log(remain)
      return <CompWait online={this.state.online} curRound={curRound} curRoundIndex={curRoundIndex} comp={comp} time={remain} onEnd={()=>this.onWaitEnd()} />
    }
    if(showRound)
    {
      let curPart = showRound.parts[curPartIndex];
      if(curPart.type=="see")
      return <CompSee online={this.state.online} forceStart={forceStart} roundIndex={curRoundIndex} partIndex={curPartIndex} round={showRound} part={curPart} comp={comp} nextTime={curPartIndex==0?5:Number(showRound.time)} curLevel={curLevel} onSetEnd={this.onSetEnd} />
        if(curPart.type=="listen")
        return <CompListen online={this.state.online} aList={aList} roundIndex={curRoundIndex} partIndex={curPartIndex}  round={showRound} part={curPart} comp={comp} nextTime={curPartIndex==0?5:Number(showRound.time)} curLevel={curLevel} onSetEnd={this.onSetEnd} />
        if(curPart.type=="online")
        return <CompOnline online={this.state.online} roundIndex={curRoundIndex} partIndex={curPartIndex}  round={showRound} part={curPart} comp={comp} nextTime={curPartIndex==0?5:Number(showRound.time)} curLevel={curLevel} onSetEnd={this.onSetEnd} />
    }
    if(!rules)
    {

    return (
      <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle} >
<TopBar width={width} />



            <div className={classes.square} style={{maxWidth:width, width: width,height:height,backgroundImage: comp&&comp.bg_nq&&comp.bg_nq.length>0?("url('"+comp.bg_nq+"')"):"url('assets/comp/bg_nq.png')",
            backgroundPosition: "center center",
            WebkitBackgroundSize: "100% 100%",
            backgroundSize: "100% 100%",position:'relative' }} elevation={4}>

              <div style={{paddingTop:STATIC.calSize(120, DWIDTH, width) + 'px '}}>{" "}</div>
              <div style={{  flexGrow: 1, position: 'relative' }}>

                <div style={{ display: 'flex', height: tHeight,flexDirection:'column', justifyContent: 'center', alignItems: 'center' }}>
                <div  style={{width: tWidth,height:tHeight,backgroundImage: "url('assets/comp/nq_table.png')",
                backgroundPosition: "center center",
                WebkitBackgroundSize: "100% 100%",
                backgroundSize: "100% 100%",position:'relative' }} elevation={4}>
                <div className="comp_table" style={{color:"#37e73e",height:tHeight-STATIC.calSize(160, DWIDTH, width),marginBottom: STATIC.calSize(60, DWIDTH, width),marginTop: STATIC.calSize(60, DWIDTH, width),marginRight: STATIC.calSize(60, DWIDTH, width),marginLeft: STATIC.calSize(60, DWIDTH, width),fontSize:fSmaller,whiteSpace: "pre-wrap",overflowX:'hidden',wordWrap: "break-word"}}>
                  {comp.rules}
                </div>
                {false&&<ButtonBase onClick={()=>{_this.caudio.pause();this.setState({isPlaying:false,rules:true,showWait:true})}} style={{position:'absolute',bottom:STATIC.calSize(70, DWIDTH, width),right:STATIC.calSize(60, DWIDTH, width),color:"#37e73e",
                textShadow: "0px 0px 10px #edfb6a",fontSize:fSmall}}>
                  {t("comp.agree")}
                </ButtonBase>}
                <ButtonBase onClick={()=>{ if(_this.caudio)_this.caudio.pause();this.setState({isPlaying:false,rules:true,showWait:true})}}  style={{position:'absolute',paddingLeft:STATIC.calSize(20, DWIDTH, width),paddingRight:STATIC.calSize(20, DWIDTH, width),bottom:STATIC.calSize(5, DWIDTH, width),right:STATIC.calSize(60, DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center',backgroundImage:"url('assets/comp/button.png')",backgroundSize:"100% 100%", marginBottom: STATIC.calSize(60, DWIDTH, width) }}>
                    <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}> {t("comp.agree")}</div>
                </ButtonBase>

                </div>

              </div>
              </div>
              <div style={{width,position:'absolute',bottom:STATIC.calSize(60, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                <div className="comp_text_gradient"  style={{fontSize:fNQ,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(640 , DWIDTH, width)*377/1427/3+"px" }}>{t('comp.rules')}</div>

              </div>
              <div style={{width,position:'absolute',bottom:STATIC.calSize(1, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>{ACCOUNTCOMP.id}</div>

              </div>
              <div  style={{position:'absolute',top:STATIC.calSize(10, DWIDTH, width),left:STATIC.calSize(280,DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src="assets/comp/sp_logo_red.png"
                  style={{ width: width*154/2048, height: 'auto', display: 'block' }} />
              </div>
              <div  style={{position:'absolute',top:STATIC.calSize(10, DWIDTH, width),left:STATIC.calSize(375,DWIDTH, width),width:width*574/2048,height:(width*574/2048)*377/1427,backgroundImage:"url('assets/comp/square_name.png')",backgroundSize:"100% 100%", textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
                <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:0.8}}>{comp?comp.name:"SUPERBRAIN\nSPEED MATH"}</div>
              </div>
              <ButtonBase onClick={()=>{

                  if(this.state.isPlaying)
                  _this.caudio.pause();
                  else
                  {
                    if(comp.rules_audio&&comp.rules_audio.length>0&&_this.caudio==undefined)
                    _this.caudio = new Audio(comp.rules_audio);
                    _this.caudio.play();
                  }

                  this.setState({isPlaying:!this.state.isPlaying})}} style={{position:'absolute',top:STATIC.calSize(50, DWIDTH, width),left:STATIC.calSize(80,DWIDTH, width)}}>
                <img
                  src="assets/comp/speaker.png"
                  style={{ width: width*asRate, height: 'auto', display: 'block' }} />
              </ButtonBase>
            </div>
            <div style={{position:'fixed',bottom:STATIC.calSize(5, DWIDTH, width),left:STATIC.calSize(5,DWIDTH, width)}}>
              <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>Online: {this.state.online}</div>

            </div>
        </div>
      </div>
    );
  }
    return (
      <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
      <div className={classes.middle} >
        <TopBar width={width} />
              <center>
              <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

                  <div>
                  <div className="comp_text_gradient"  style={{fontSize:fBig,whiteSpace: "pre",textAlign:'center',lineHeight:STATIC.calSize(640 , DWIDTH, width)*377/1427/3+"px" }}>{"Chúc Mừng\nCác thí sinh\n hoàn thành bài thi"}</div>
                  </div>

              </div>
              {curRoundIndex>0&&<ButtonBase onClick={()=>window.open(shareUrl,"_blank")} style={{position:'absolute',paddingLeft:STATIC.calSize(20, DWIDTH, width),paddingRight:STATIC.calSize(20, DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center',backgroundImage:"url('assets/comp/button.png')",backgroundSize:"100% 100%",top:STATIC.calSize(50, DWIDTH, width),right:STATIC.calSize(10,DWIDTH, width)}}>
                <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{"Xem lại kết quả"}</div>
              </ButtonBase>}

              </center>
              <div style={{position:'fixed',bottom:STATIC.calSize(5, DWIDTH, width),left:STATIC.calSize(5,DWIDTH, width)}}>
                <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>Online: {this.state.online}</div>

              </div>
          </div>

      </div>
    );

  }
}

CompHome.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles2)(STATIC.translate('common')(CompHome));
